const withRightPlural = (text: string, amount: number, postfix?: string) => {
  if (amount > 1) return postfix ? `${text}${postfix}` : `${text}s`;
  return text;
};

export default withRightPlural;
